import { TextSource } from './types';

/**
 * Texte der Startseite.
 *
 * Nicht enthalten sind die Alternativtexte der Bilder: Sie sind auf der Seite
 * unsichtbar und ließen sich im Bearbeiten-Modus, der ja an der sichtbaren Stelle
 * hängt, gar nicht anzeigen. Sie bleiben im Code.
 */
export const HOME: TextSource = {
  'home.hero.eyebrow': 'Aus Gifhorn · für die Region 38',
  'home.hero.titel': 'Zuhause bleiben.',
  'home.hero.titel-akzent': 'Liebevoll begleitet.',
  'home.hero.lead':
    'In Gifhorn und Umgebung begleiten wir ältere Menschen zuverlässig — von den ersten Handgriffen im Haushalt bis zur liebevollen 24-Stunden-Betreuung.',
  'home.hero.cta-beratung': 'Kostenlose Beratung anfragen',
  'home.hero.cta-whatsapp': 'WhatsApp schreiben',
  'home.hero.fakt-1.wert': { text: 'seit 2017', max: 20 },
  'home.hero.fakt-1.text': { text: 'für die Region da', max: 34 },
  'home.hero.fakt-2.wert': { text: '7 Tage', max: 20 },
  'home.hero.fakt-2.text': { text: 'im Notfall erreichbar', max: 34 },

  'home.leistungen.hauswirtschaft.titel': 'Stundenweise Hauswirtschaft',
  'home.leistungen.hauswirtschaft.text':
    'Für ein gepflegtes Zuhause ganz nach Ihren Vorstellungen — flexibel und stundenweise.',
  'home.leistungen.hauswirtschaft.link': 'Mehr erfahren',
  'home.leistungen.24h.titel': '24-Stunden-Betreuung',
  'home.leistungen.24h.text':
    'Liebevolle Rundum-Betreuung in vertrauter Umgebung — mit erfahrenen Betreuungskräften.',
  'home.leistungen.24h.link': 'Mehr erfahren',

  'home.inhaber.titel': 'Gepflegt zuhause bleiben',
  'home.inhaber.claim': 'Warum unsere häusliche Seniorenbetreuung zu den Besten zählt.',
  'home.inhaber.absatz-1':
    'Viele Menschen hegen den Wunsch, ihren Lebensabend in vertrauter Umgebung zu verbringen, umgeben von den Menschen, die ihnen am nächsten stehen. Diesen Herzenswunsch zu erfüllen ist unser wesentliches Ziel.',
  'home.inhaber.absatz-2':
    'Unser Team besteht aus sorgfältig ausgewähltem Personal, das mit großer Wertschätzung und Hingabe arbeitet — fachlich kompetent, empathisch und einfühlsam.',
  'home.inhaber.name': { text: 'Roman Antczak', max: 40 },
  'home.inhaber.rolle': { text: 'Inhaber', max: 40 },
  'home.inhaber.cta': 'Mehr über uns',

  'home.auszeichnung.titel': 'Was uns auszeichnet',
  // Die Reihenfolge entspricht den Symbolen in der Seite; die Symbole selbst
  // bleiben im Code, weil sie sich nicht sinnvoll eintippen lassen.
  'home.auszeichnung.1': { text: 'Individuelle Betreuungsangebote', max: 46 },
  'home.auszeichnung.2': { text: 'Transparente Kosten', max: 46 },
  'home.auszeichnung.3': { text: 'Familienunternehmen', max: 46 },
  'home.auszeichnung.4': { text: 'Lokal verankert', max: 46 },
  'home.auszeichnung.5': { text: 'Flexible Vertragslaufzeiten', max: 46 },

  'home.info.titel': 'Häusliche Betreuung und Pflege — auf jeden persönlich zugeschnitten',
  'home.info.absatz-1':
    'In herausfordernden Zeiten stehen wir Ihnen zur Seite und helfen, Ihre Angehörigen in vertrauter Umgebung bestmöglich zu versorgen — mit der „24h-Betreuung“ oder stundenweiser Hauswirtschaft.',
  'home.info.absatz-2':
    'Als anerkanntes Unternehmen im Sinne des §45a Abs. 1 und §45b Abs. 1 Nr. 4 SGB XI rechnen wir stundenweise Hauswirtschaft direkt mit den Pflegekassen ab. Unser Büro in Gifhorn ist an 5 Tagen die Woche besetzt — im Notfall erreichen Sie uns an 7 Tagen.',
  'home.info.cta': 'Jetzt Kontakt aufnehmen',


  // Entwurf Neuaufbau: Auswahlkarte im Kopf, Vertrauenszeile, Ablauf.
  'home.wahl.titel': { text: 'Wobei dürfen wir helfen?', max: 40 },
  'home.wahl.hw.titel': { text: 'Stundenweise Hauswirtschaft', max: 40 },
  'home.wahl.hw.text': { text: 'Putzen, Wäsche, Einkauf, Begleitung', max: 50 },
  'home.wahl.24h.titel': { text: '24-Stunden-Betreuung', max: 40 },
  'home.wahl.24h.text': { text: 'Betreuungskraft lebt mit im Haushalt', max: 50 },
  'home.wahl.anrufen': { text: 'Oder direkt anrufen:', max: 30 },
  'home.vertrauen.kasse.wert': { text: 'Pflegekasse', max: 24 },
  'home.vertrauen.kasse.text': { text: 'rechnet Hauswirtschaft direkt ab', max: 40 },
  'home.vertrauen.familie.wert': { text: 'Familienbetrieb', max: 24 },
  'home.vertrauen.familie.text': { text: 'mit Büro am Steinweg in Gifhorn', max: 40 },
  'home.ablauf.eyebrow': { text: 'So läuft es ab', max: 30 },
  'home.ablauf.titel': { text: 'Vom ersten Anruf bis zur festen Hilfe', max: 60 },
  'home.ablauf.1.titel': { text: 'Anrufen oder schreiben', max: 40 },
  'home.ablauf.1.text': 'Sie erzählen uns, wie es zu Hause gerade aussieht. Die Beratung ist kostenlos und unverbindlich.',
  'home.ablauf.2.titel': { text: 'Kennenlernen bei Ihnen', max: 40 },
  'home.ablauf.2.text': 'Wir kommen vorbei und klären mit Ihnen und Ihren Angehörigen, was wirklich gebraucht wird.',
  'home.ablauf.3.titel': { text: 'Passende Hilfe', max: 40 },
  'home.ablauf.3.text': 'Sie bekommen eine feste Ansprechperson und eine Betreuung, die zu Ihrem Alltag passt.',
  'home.ablauf.4.titel': { text: 'Wir bleiben erreichbar', max: 40 },
  'home.ablauf.4.text': 'Das Büro ist an fünf Tagen besetzt, im Notfall erreichen Sie uns an sieben Tagen.',
  'home.leistungen.titel': { text: 'Zwei Wege, gut versorgt zu bleiben', max: 60 },

  'home.stimmen.titel': { text: 'Was Angehörige sagen', max: 60 },
  'home.stimmen.1.zitat':
    'Ich war auf der Suche nach einer 24-Stunden-Betreuung für meine Mutter. Ich wurde sehr gut aufgeklärt und bekam direkt passende Angebote. Ich bin sehr zufrieden gewesen.',
  'home.stimmen.1.name': { text: 'Michaela R.', max: 40 },
  'home.stimmen.2.zitat':
    'Die Kontaktaufnahme erfolgte schnell und freundlich. Ich habe mich kompetent beraten gefühlt und kann den Ansprechpartner nur weiterempfehlen!',
  'home.stimmen.2.name': { text: 'Silke P.', max: 40 },
  'home.stimmen.3.zitat':
    'Vielen herzlichen Dank für die Hilfe. Schnell, freundlich und nicht aufdringlich — aber man nimmt sich Zeit. So konnten wir den besten Anbieter aussuchen.',
  'home.stimmen.3.name': { text: 'Uwe H.', max: 40 },

  'home.team.titel': 'Unser Team',
  'home.team.text':
    'Unsere engagierten Mitarbeiter kümmern sich liebevoll, kompetent und einfühlsam um die Anliegen unserer Kunden.',

  'home.aktuelles.titel': 'Aktuelles',
  'home.aktuelles.link': 'Alle Beiträge',
};

export default HOME;
